export default "__VITE_ASSET__dZ3wQk1T__"